<template>
  <div>
    <v-row v-if="showCancellations">
      <v-col cols="12">
        <gg-card>
          <gg-card-header>
            My Cancellations
          </gg-card-header>
          <gg-card-text>
            <gg-loading :loading="loading" type="table">
              <v-data-table
                :headers="headers"
                :items="cancellations"
                :loading="loading"
                :footer-props="{ itemsPerPageOptions: paginationBilling }"
              >
                <template v-slot:item.id="{ item }">
                  <router-link :to="`/cancellations/${item.id}`">
                    <strong>#{{ item.id }}</strong>
                  </router-link>
                </template>
                <template v-slot:item.product="{ item }">
                  {{ item.product }} <br>
                  {{ item.domain }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-icon small class="pb-1" :color="statusColor(item.status)">mdi-circle</v-icon>
                  {{ statusNameFormatter(item.status) }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <gg-btn :to="`/cancellations/${item.id}`">
                    View Details
                  </gg-btn>
                </template>
              </v-data-table>
            </gg-loading>
          </gg-card-text>
        </gg-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { statusColor, statusNames } from 'Helpers/helpers'

export default {
  name: 'CancellationsList',
  data: () => ({
    loading: false,
    headers: [
      { text: 'ID Number', sortable: false, value: 'id' },
      { text: 'Service', sortable: false, value: 'product' },
      { text: 'Status', sortable: false, value: 'status' },
      { text: 'Type', sortable: false, value: 'type' },
      { text: 'Date Generated', sortable: false, value: 'date_generated' },
      { text: 'Actions', sortable: false, value: 'actions', align: 'center' },
    ],
  }),
  async created () {
    await this.getData()
  },
  computed: {
    ...mapGetters(['cancellations', 'paginationBilling']),
    showCancellations () {
      return this.cancellations.length > 0
    },
  },
  methods: {
    ...mapActions(['getCancellations', 'reportSuccess', 'reportError']),
    statusColor,
    statusNameFormatter (name) {
      return statusNames[name]
    },
    async getData () {
      try {
        this.loading = true
        await this.getCancellations()
        this.loading = false
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
  }
}
</script>
